export function sendEmail(data) {
  return {
    path: "contacts/send-email",
    method: "POST",
    data
  };
}
